const approachTypes = {
 Colaborativo: 1,
 ServicioMixto: 2,
 SalonRecurso: 3,
 MaestroConsultor: 7
};

export default approachTypes;
